import script from "./UpdateMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateMemoPage.vue?vue&type=style&index=0&id=3d708672&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d708672"]])

export default __exports__